import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box, themeColor } from '@elparking/components'
import styled from 'styled-components'

const colorBorder = ({selected}) => selected
    ? themeColor('main')
    : 'transparent'

const colorLink = ({selected}) => selected
    ? themeColor('main')
    : themeColor('gray')

const TabContainer = styled(Box)`
    border-bottom: 4px solid ${colorBorder};
`

const TabLink = styled.a`
    color: ${colorLink};
    cursor: pointer;
`

function Tab ({name, href, selected}) {
    return (
        <TabContainer px={['12px', '24px']} selected={selected}>
            <Copy textAlign='center' color={selected ? 'main' : 'gray' } padding={['16px 0px']} fontWeight='book' fontSize={['medium', 'xLarge']}>
                <TabLink selected={selected} href={href}>
                    {name}
                </TabLink>
            </Copy>
        </TabContainer>
    )
}

Tab.propTypes = {
    name: PropTypes.string,
    href: PropTypes.string,
    selected: PropTypes.bool,
}

export default Tab
